import Module, { moduleInit, ViewLayer, bindButtonClickEvent } from "../../../../../framework/core/mvvm/module_base";
import { IconEditorView } from "./icon_editor_view";
import AppController from "../../../../../sdk/app_controller";
import CryptoJS = require("crypto-js");
import Utility from "../../../../../utility/utility";
import OssManager from "../../../../../manager/oss_manager";
import ModelData, { IUserData } from "../../../../public/model_data";
import UserDataManager from "../../../../../manager/user_manager";
import GameUtil from "../../../../../utility/game_util";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("IconEditor")
export default class IconEditor extends Module<IconEditorView, null> {

    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.viewType = IconEditorView;
        this.windowPrefabResPath = "package/hall/module/playericon/Public_icon_editor";
        this.needAnim = false;
        this.needViewMask = false;
        this.clickAnywhereClose = false;
        this.needDeferShow = true;
    }

    private photoData:any = null;

    onInit(){
        this.view.init();
        this.eventBind('OnShowPhotoCallback',this.receivePhoto)
        this.eventBind('OnCancelPhotoCallback',this.canclePhoto)
        this.eventBind('_on_hide_playerInfo_',this.onHidePlayerInfo)
    }

    onShow(){
        
    }

    onDeferShow(){
        UserDataManager.getData(ModelData.instance.roleData.id, (data: IUserData)=>{
            if(this && this.isValid){
                this.view.refreshPlayerId(data.id)
                this.view.refreshPlayerIcon(data.avatarSprite)
                this.show()
            }
        }, false)
    }

    @bindButtonClickEvent("localImage")
    onLocalImageBtn(){
        cc.log('photo')
        let size = this.view.avatarSize();
        AppController.instance.openAlbum(size.width+100,size.height+100);
    }

    @bindButtonClickEvent("photoimage")
    photoimageBtn(){
        cc.log('local camera')
        let size = this.view.avatarSize();
        AppController.instance.openCamera(size.width+100,size.height+100);
    }


    canclePhoto(){
        this.photoData = null;
    }

    receivePhoto(data:any){
        if (data && this.nodeIsValid) {
            let self = this;
            this.photoData = data;
            let strImg = "data:image/jpg;base64," + data.img.toString();
            let img = new Image();
            img.src = strImg
            let texture = new cc.Texture2D();
            texture.initWithElement(img);
            texture.handleLoadedTexture();
            self.view.setSelectImage(texture,null);

            //选取图片及时上传
            if (this.photoData) {
                this.uploadJpg()
                this.photoData = null;
                return;   
            }
        }
    }

    protected uploadJpg(){
        cc.log('photo uploadJpg')
        if (!this.photoData) {
            return;
        }

        let str = this.photoData.img.toString();
        if (!str) {
            return;
        }

        let name = CryptoJS.MD5(this.photoData.img).toString();
        let key = name + '.jpg'

        var base64 = this.photoData.img
        let raw = Utility.atob(base64);

        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));

        for(let i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }

        let uploadTimes = 3 //上传失败后的重试次数
        let self = this;
        OssManager.instance.upload_jpg(key, array, function(url){
            if (self.nodeIsValid) {
                self.changeIcon(url,ModelData.instance.roleData.gender);
            }
        }, function(){}, uploadTimes)
    }

    changeIcon(iconName:string,gender:number){
        cc.log('icon',iconName,gender)
        if (!iconName || !gender) {
            return;
        }

        this.reqChangeIcon(iconName, gender, ()=>
        {
            this.view.beforUploadImage(iconName);
            UserDataManager.getDataFromServer(ModelData.instance.roleData.id, ()=>{});
            this.eventDispatch('player_avatar_data_changed', ModelData.instance.roleData.id, true)
        })
    }

    reqChangeIcon(iconName: string,gender: number, callback) {
        let requestData = {
            baseUrl: "user/editInfo?",
            params: {
                gameUserId: ModelData.instance.roleData.id,
                gender: gender,
                headImg: iconName,
            }
        }
        let self = this;
        GameUtil.apiHttpGet(requestData, function (retData) {
            if (self.nodeIsValid) {
                if (callback) {
                    callback(retData.data)
                }
            } 
        })
    }

    beforUploadImage(curUrl:string){
       this.view.beforUploadImage(curUrl);
    }

    hideInfoSetting(){
        let url = this.view.getSelectData();
        let roleData = ModelData.instance.roleData
        if (url && url.length > 0 && roleData.avatar != url) {
            this.changeIcon(url,roleData.gender);
        }
        this.view.resetIconPanelData()
        this.photoData = null;
    }

    onHidePlayerInfo(){
        this.hideInfoSetting();
    }
  
    onHide(){
        
    }
}
